import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    title: "Romulus API",
    logo: {
      src: {
        light: "/logo-dark.png",
        dark: "/logo.png",
      },
      alt: "Romulus",
      width: "120px",
    },
    favicon: "/favicon.png",
    metadata: {
      title: "%s - Romulus API",
    },
  },
  // redirects: [{ from: "/", to: "/docs/introduction" }],
  apis: [
    {
      type: "file",
      input: "./openapi.yaml",
      path: "/api",
      options: {
        expandAllTags: false,
      },
    },
  ],
  docs: {
    files: "pages/**/*.{md,mdx}",
  },
  navigation: [
    {
      type: "category",
      label: "Getting Started",
      items: [
        { type: "doc", file: "introduction", label: "Introduction" },
      ],
    },
    {
      type: "link",
      label: "API Reference",
      to: "/api",
    },
    {
      type: "category",
      label: "Reference",
      items: [
        { type: "doc", file: "click_to_call", label: "Click to Call" },
        { type: "doc", file: "errors", label: "Error Codes" },
      ],
    },
  ],
};

export default config;
